import { render, staticRenderFns } from "./netoIvaTotal.vue?vue&type=template&id=2646c15a&"
import script from "./netoIvaTotal.vue?vue&type=script&lang=js&"
export * from "./netoIvaTotal.vue?vue&type=script&lang=js&"
import style0 from "./netoIvaTotal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports